module.exports = __webpack_public_path__ + "fonts/Barlow-Italic.bf3cd14b.woff";